import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import { DateInput as SharedDateInput } from "../../shared/DateInput";

export const DateInput: FC<InputProps<string>> = ({ ...props }) => <SharedDateInput {...props} />;
